import {API} from '@/app-core/api/Api'

export default {

  async Send(data = {}) {
    const Endpoint = API.Endpoint.Contact.Send
    const Data = data
    return await API.RESTRequest(Endpoint, Data)
  }

}
